import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {PitUser} from "../../../../pit-shared/domain/pit-user";
import {PitResponsibleUser} from "../../../../pit-shared/domain/pit-responsible-user";
import {DxNciDictionaryItem} from "../../../../dx-nci-core/domain/dx-nci-dictionary-item";
import {PitUsersService} from "../../../../pit-shared/services/pit-users.service";
import {PitResponsiblesService} from "../../../../pit-shared/services/pit-responsibles.service";
import {DxNciService} from "../../../../dx-nci-core/services/dx-nci.service";
import {DxModalService} from "../../../../dx-modals/services/dx-modal.service";
import {DxModalResultType} from "../../../../dx-modals/domain/dx-modal-result-type";


const LOADING_MESSAGE: string = 'Идёт загрузка данных';

@Component({
  selector: 'pit-responsible-users',
  templateUrl: './pit-responsible-users.component.html',
  styleUrls: ['./pit-responsible-users.component.css']
})
export class PitResponsibleUsersComponent implements OnInit, OnChanges {

  @Input()
  anObject: {id: number};

  @Input()
  anObjectTypeId: number;

  usersDict: PitUser[];
  responsibleUsers: PitResponsibleUser[];
  responsibilityTypes: DxNciDictionaryItem[];

  formGroup: FormGroup = new FormGroup({});

  isInitialized: boolean = false;

  /** индикация загрузки. */
  isLoading: boolean = false;
  loadingMessage: string = '';

  protected _showLoader(message?: string): void {
    if (message) {
      this.loadingMessage = message;
    }
    this.isLoading = true;
  }

  protected _hideLoader(): void {
    this.isLoading = false;
  }

  trackById = (index, respUser: PitResponsibleUser) => respUser.id + '_' + respUser.responsibilityTypeId;

  constructor(private usersService: PitUsersService,
              private responsiblesService: PitResponsiblesService,
              private nciService: DxNciService,
              private modalService: DxModalService) {
  }

  ngOnInit() {
    this.ngOnChanges();
  }

  ngOnChanges() {
    if(this.anObject.id && !this.isInitialized) {
      this.initAll().then();
    }
  }

  async initAll(): Promise<void> {
    this.isInitialized = true;
    this._showLoader(LOADING_MESSAGE);
    this.usersDict = await this.usersService.getUsers().toPromise();
    this.responsibilityTypes = (await this.nciService.fetchBackendDictionary('responsibility-type').toPromise()).elements;
    const allRespUsers = await this.responsiblesService.getAll(this.anObject.id, this.anObjectTypeId).toPromise();

    if (allRespUsers) {
      this.responsibleUsers = allRespUsers.responsibleUsers;
      this.initControls();
    }
    this._hideLoader();
    return Promise.resolve();
  }

  initControls() {
    this.responsibleUsers.forEach(
      (respUser, index) => {
        let control = this.formGroup.controls['responsibleUserCombo' + respUser.id] = new FormControl(null, []);
        control.setValue(respUser.userId);
      }
    );
  }

  getResponsibilityTypeName(typeId: number): string {
    return this.responsibilityTypes.find(type => type.id === typeId).name;
  }

  onRecreateButton() {
    this.modalService.showConfirm('Вы уверенны, что хотите пересоздать ответственных?').subscribe(
      result => {
        if (result.type === DxModalResultType.OK) {
          this.onCreateButton();
        }
      }
    )
  }

  onCreateButton() {
    this._showLoader(LOADING_MESSAGE);
    this.responsiblesService.create(this.anObject.id, this.anObjectTypeId).subscribe(
      allRespUsers => {
        this.responsibleUsers = allRespUsers.responsibleUsers;
        this.initControls();
        this._hideLoader();
      }
    );
  }

  onValueChange(respUserId: number, userId: number) {
    const respUser = this.responsibleUsers.find(respUser => respUser.id === respUserId);
    // назначили ответственного
    respUser.userId = userId;
    this.responsiblesService.updateEntry(this.anObject.id, this.anObjectTypeId, respUser).subscribe();
  }

}
